import { render, staticRenderFns } from "./MSIndReg.vue?vue&type=template&id=a8f4b31c"
import script from "./MSIndReg.vue?vue&type=script&lang=js"
export * from "./MSIndReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports